<div class="container-fluid px-4 mt-4 mb-5">
    <!-- Page Header -->
    <div class="cp-page-header mb-4">
        <div class="cp-page-title">
            <i class="fa-solid fa-folder-open me-2"></i>
            Registro de Controles
        </div>
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><a routerLink="/control-ingreso">Control de Ingreso</a></li>
                <li class="breadcrumb-item active">Registros</li>
            </ol>
        </nav>
    </div>

    <div class="row">
        <div class="col-xl-12">
            <ul ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-tabs">
                <li [ngbNavItem]="1">
                    <a ngbNavLink>CONTROL DE INGRESO</a>
                    <ng-template ngbNavContent>
                        <app-list-controls />
                    </ng-template>
                </li>
                <li [ngbNavItem]="2">
                    <a ngbNavLink>CONTROL DE RONDAS</a>
                    <ng-template ngbNavContent>
                        <app-list-rounds />
                    </ng-template>
                </li>
                <li [ngbNavItem]="3">
                    <a ngbNavLink>LISTA DE TAREAS</a>
                    <ng-template ngbNavContent>
                        <app-list-tasks-facility [lockFacility]="false" />
                    </ng-template>
                </li>
            </ul>
            <div [ngbNavOutlet]="nav" class="mt-2"></div>
        </div>
    </div>

</div>